/**
 * Cookie Policy 页面
 * 优先从接口拉取 Markdown，fallback 到静态内容
 */

import React, { useEffect, useState } from 'react';
import { fetchCookiePolicyContent } from '../util/cmpApi';
import { marked } from 'marked';
import TopLogo from '../component/TopLogo';
// 静态 fallback
import staticCookieMd from '../const/md/cookie.md';

interface CookiePolicyProps {
  fallbackHtml: string;
}

export default function CookiePolicyPage({ fallbackHtml }: CookiePolicyProps) {
  const [html, setHtml] = useState<string>(fallbackHtml);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const data = await fetchCookiePolicyContent();
        if (cancelled) return;

        if (data?.contentMarkdown) {
          // marked v4.x 是同步的
          const parsedHtml = marked.parse(data.contentMarkdown) as string;
          setHtml(parsedHtml);
        }
      } catch (e) {
        console.warn('[CookiePolicy] Failed to fetch from API, using fallback');
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <TopLogo />
      <div className="news-detail-md" style={{ opacity: loading ? 0.7 : 1 }}>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </>
  );
}

// SSG：提供静态 fallback HTML
export async function getStaticProps() {
  // 静态 Markdown 已经被 markdown-loader 转换为 HTML
  return {
    props: {
      fallbackHtml: staticCookieMd || '',
    },
  };
}

